module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aeiTx"))).then(() => parcelRequire('ljYL6'));